if (!customElements.get('cart-terms-2')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        // alert('You must agree to the shipping policy before continuing'); // eslint-disable-line
        document.getElementById('error-message-2').style.display = 'block';
      } else {
        document.getElementById('error-message-2').style.display = 'none';
      }
    }
  }
  customElements.define('cart-terms-2', CartTerms);
}
